export default function LegalDoc({ blocks }) {
  return (
    <div>
      {blocks.map((b, i) => {
        if (b.type === "h2") {
          return <h2 key={i} className="text-xl font-extrabold text-stone-900 tracking-tight mt-10 mb-3">{b.text}</h2>;
        }
        if (b.type === "h3") {
          return <h3 key={i} className="text-base font-bold text-stone-900 mt-6 mb-2">{b.text}</h3>;
        }
        if (b.type === "ul") {
          return (
            <ul key={i} className="list-disc pl-5 space-y-1 mb-4 text-sm text-stone-600 leading-relaxed">
              {b.items.map((it, j) => <li key={j}>{it}</li>)}
            </ul>
          );
        }
        if (b.type === "address") {
          return (
            <address key={i} className="not-italic text-sm text-stone-600 leading-relaxed mb-4">
              {b.lines.map((l, j) => <div key={j}>{l}</div>)}
            </address>
          );
        }
        return <p key={i} className="text-sm text-stone-600 leading-relaxed mb-3">{b.text}</p>;
      })}
    </div>
  );
}
